import React from 'react'
import TwentyTwentySource from '../services/twentyTwenty/TwentyTwentySource'
import EyeMedVerify from '../services/eyemed/EyeMedVerify'
import SpecteraVerify from '../services/spectera/claimForm/SpecteraVerify'
import VersantVerify from '../services/versant/claimForm/VersantVerify'
import EyeFinityVerify from '../services/eyefinity/EyeFinityVerify'
import VbaVerify from '../services/vba/VbaVerify'
import NvaVerify from '../services/nva/NvaVerify'
import CecVerify from '../services/cec/CecVerify'

export const RenderRPAService = (props) => {
  const { pprops } = props

  const getServiceName = (serviceName) => {
    const service = pprops.services.find((item) => item.config.service == serviceName)
    return service?.insurance_names?.includes(pprops.selectedInsuranceName) ? pprops.selectedInsuranceName : ''
  }

  switch (pprops.selectedInsuranceName) {
    case getServiceName('2020source'):
      return <TwentyTwentySource pprops={pprops} />
    case getServiceName('eyemed'):
      return <EyeMedVerify pprops={pprops} />
    case getServiceName('eyefinity'):
      return <EyeFinityVerify pprops={pprops} />

    case getServiceName('spectera'):
      return <SpecteraVerify pprops={pprops} />

    case getServiceName('versant'):
      return <VersantVerify pprops={pprops} />

    case getServiceName('vba'):
      return <VbaVerify pprops={pprops} />

    case getServiceName('nva'):
      return <NvaVerify pprops={pprops} />

    case getServiceName('cec'):
      return <CecVerify pprops={pprops} />

    default:
      return ''
  }
}